// extracted by mini-css-extract-plugin
export default {"logoFsfbHeaderWhite":"HeaderLogoWhite_logoFsfbHeaderWhite__i9Vmn"};